"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Debug = void 0;
class Debug {
}
exports.Debug = Debug;
Debug.nodes = false; //color each node
Debug.culling = false; //visibility culling disabled
Debug.draw = false; //final rendering call disabled
Debug.extract = false; //no extraction
Debug.request = false; //no network requests
